import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import ImportDataModal from '../components/ImportData/ImportDataModal';
import RequestDataModal from '../components/RequestData/RequestDataModal';
import ProfileEditModal from '../components/ProfileHeader/ProfileEditModal';
var ModalContext = /*#__PURE__*/React.createContext();

var ModalProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalProvider, _React$Component);

  var _super = _createSuper(ModalProvider);

  function ModalProvider(_props) {
    var _this;

    _classCallCheck(this, ModalProvider);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "toggleImportDataModal", function (open) {
      _this.setState({
        isImportDataModalOpen: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleRequestDataModal", function (open) {
      _this.setState({
        isRequestDataModalOpen: open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleProfileEditModal", function (open) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _this.setState({
        isProfileEditModalOpen: open,
        profileEditModalProps: props
      });
    });

    _this.state = {
      isImportDataModalOpen: false,
      isRequestDataModalOpen: false,
      isProfileEditModalOpen: false,
      profileEditModalProps: {}
    };
    return _this;
  }

  _createClass(ModalProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(ModalContext.Provider, {
        value: {
          toggleImportDataModal: this.toggleImportDataModal,
          toggleRequestDataModal: this.toggleRequestDataModal,
          toggleProfileEditModal: this.toggleProfileEditModal
        }
      }, this.props.children, /*#__PURE__*/React.createElement(ImportDataModal, {
        isOpen: this.state.isImportDataModalOpen,
        onClose: function onClose() {
          return _this2.toggleImportDataModal(false);
        }
      }), /*#__PURE__*/React.createElement(RequestDataModal, {
        isOpen: this.state.isRequestDataModalOpen,
        onClose: function onClose() {
          return _this2.toggleRequestDataModal(false);
        }
      }), /*#__PURE__*/React.createElement(ProfileEditModal, _extends({
        isOpen: this.state.isProfileEditModalOpen,
        onClose: function onClose() {
          return _this2.toggleProfileEditModal(false);
        }
      }, this.state.profileEditModalProps)));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ModalProvider;
}(React.Component);

var withModal = function withModal(Component) {
  return function WrapperComponent(props) {
    return /*#__PURE__*/React.createElement(ModalContext.Consumer, null, function (context) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, context));
    });
  };
};

export { ModalContext, ModalProvider, withModal };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ModalContext, "ModalContext", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/ModalContext.js");
  reactHotLoader.register(ModalProvider, "ModalProvider", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/ModalContext.js");
  reactHotLoader.register(withModal, "withModal", "/home/runner/html/nextcloud/apps/ehr/js/platform/main/src/context/ModalContext.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();